angular
  .module('capability-ng-notification-settings')
  .provider('notificationSettingsConfiguration', function notificationSettingsConfiguration() {
    let DEFAULTS = {
      growlerHandle: ''
    };
    let configuration = _.merge({}, DEFAULTS);

    let configure = (this.configure = (config) => {
      if (!!config) {
        configuration = _.merge({}, DEFAULTS, config);
      }

      return configuration;
    });

    let read = (this.read = () => configuration);

    this.activate = (config) => this.configure(config);

    this.$get = () => {
      return {
        configure,
        read
      };
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/config/notification_settings_configuration.es.js